import React from 'react';
import PopupEditTotalPayment from '../../OrdersPage/components/PopupEditTotalPayment';

export function OrderTotalPaymentColumnFormatter(cellContent) {
  const totalPaymentValue = cellContent.totalPayment ? parseFloat(cellContent.totalPayment) : 0;

  return (
    <div
      className="text-dark-75 font-weight-bolder d-flex align-items-center font-size-h5 text-nowrap"
    >
      <PopupEditTotalPayment orderID={cellContent.orderNumber} totalPayment={totalPaymentValue}/>
      <div className={'pr-2'}>
        {totalPaymentValue
          ? (totalPaymentValue).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})
          : ''
        }
      </div>
    </div>
  );
}
